export const tagsRel ={
    headers:[
        { key: "cnpj", label: "CNPJ"},
        { key: "empresa", label: "Empresa"},
        { key: "ano", label: "Ano"},
        { key: "nivelConsci", label: "Nível de consciência"},
        { key: "nivelPlanoTrab", label: "Estrutura segurança"},
        { key: "nivelConform", label: "Nível de Conformidade"},
        { key: "nivelInclusao", label: "Inclusão grandes cenários"},
        // Estabelecer uma cultura em segurança de processo
        { key: "agendaSegurancaReunioes", label: "Agenda segurança reuniões"},
        { key: "segurancaPlanosOrcamentos", label: "Segurança planos orçamentos"},
        { key: "preocupacoesSegurancaOperacional", label: "Preocupações segurança operacional"},
        { key: "statusSegurancaReunioes", label: "Status segurança reuniões"},
        { key: "acaoManutencaoFalhas", label: "Ação manutenção falhas"},
        // Proporcionar liderança e compromisso da alta liderança
        { key: "operadoresBarreirasProcesso", label: "Operadores barreiras processo"},
        { key: "atividadesSegurancaGestao", label: "Atividades segurança gestão"},
        { key: "atribuicaoBaseCompetencia", label: "Atribuição base competência"},
        { key: "melhoriasSistemaGestao", label: "Melhorias sistema gestão"},
        // Implementar um programa detalhado de GSPM
        { key: "treinamentoPadroesSeguranca", label: "Treinamento padrões segurança"},
        { key: "avaliacaoDesviosPadroes", label: "Avaliação desvios padrões"},
        { key: "verificacaoEquipamentosExistentes", label: "Verificação equipamentos existentes"},
        { key: "atualizacaoPadroesEquipamentos", label: "Atualização padrões equipamentos"},
        { key: "treinamentoRiscosLocal", label: "Treinamento riscos local"},
        { key: "avaliacaoLimitesOperacionais", label: "Avaliação limites operacionais"},
        { key: "modificacoesProcessosEquipamentos", label: "Modificações processos equipamentos"},
        // Aprender com a Experiência
        { key: "especialistasInvestigacoesIncidentes", label: "Especialistas investigações incidentes"},
        { key: "investigacaoCausasRaiz", label: "Investigação causas raiz"},
        { key: "licoesAprendidasEmpresa", label: "Lições aprendidas empresa"},
        { key: "discussaoInvestigacoesReunioes", label: "Discussão investigações reuniões"},
        { key: "aprendizadosPadroesInternos", label: "Aprendizados em padrões internos"},
        { key: "observacoes", label: "Observações"},
        { key: "createdAt", label: "Inserido"},
        { key: "updatedAt", label: "Atualizado"},
    ]
}

export const optionsDropdown = [
    {
      id: 1,
      label:"Raramente ou nunca"
    },
    {
      id: 2,
      label: "Algumas vezes"
    },
    {
      id: 3,
      label: "Na maioria das vezes"
    },
    {
      id: 4,
      label: "Sempre"
    }
  ]
